module.exports = __webpack_public_path__ + "static/img/suplementos_eggbiscuits.003abcf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/suplementos_eggbiscuits.jpg
// module id = X8G4
// module chunks = 0